import { make } from 'vuex-pathify';

const site = {
  namespaced: true,
  state: {
    locked: true,
    activeFont: 'Gorditas',
    options: {
      topNav: {
        show: {
          search: true,
          uploadVideo: false,
          notifications: false,
          messages: false,
        },
      },
      videos: {
        show: {
          placeholders: false,
          duration: true,
          title: true,
          tags: true,
          views: true,
          date: true,
          timeAgo: true,
          optionsDropdown: true,
        },
      },
      video: {
        show: {
          page: {
            ads: false,
            channel: false,
            playlist: false,
            suggested: false,
            comments: false,
          },
          video: {
            thumbnail: true,
            title: true,
            description: true,
            tags: true,
          },
        },
      },
    },
  },
  mutations: {},
  actions: {},
};

site.mutations = make.mutations(site.state);

export default site;
